import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiEndpoints } from '../api/client';

const Upgrade = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      setLoading(true);

      const data = await apiEndpoints.stripe.createCheckoutSession(
        `${window.location.origin}/payment/success`,
        `${window.location.origin}/upgrade`
      );

      // Redirect to Stripe checkout
      window.location.href = data.url;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      alert('Failed to start checkout. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Upgrade to Pro</h1>
        <p style={styles.subtitle}>
          Unlock unlimited access to all AI-powered features
        </p>

        <div style={styles.pricingCard}>
          <div style={styles.badge}>Most Popular</div>

          <h2 style={styles.planName}>Pro Plan</h2>

          <div style={styles.pricing}>
            <span style={styles.originalPrice}>$29.99</span>
            <span style={styles.price}>$19.99</span>
            <span style={styles.period}>/month</span>
          </div>

          <ul style={styles.featuresList}>
            <Feature text="Unlimited AI Resume Generation" />
            <Feature text="Unlimited AI Copilot (Master & Resume)" />
            <Feature text="Unlimited Mock Interviews" />
            <Feature text="Unlimited STAR Story Generation" />
            <Feature text="Unlimited Company Research" />
            <Feature text="Unlimited Resume Practice Sessions" />
            <Feature text="Priority Support" />
            <Feature text="Cancel Anytime" />
          </ul>

          <button
            style={loading ? {...styles.subscribeButton, ...styles.subscribeButtonLoading} : styles.subscribeButton}
            onClick={handleSubscribe}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Subscribe Now'}
          </button>

          <p style={styles.secureNote}>
            🔒 Secure payment powered by Stripe
          </p>
        </div>

        <button style={styles.backButton} onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

const Feature = ({ text }) => (
  <li style={styles.feature}>
    <span style={styles.checkmark}>✓</span>
    <span>{text}</span>
  </li>
);

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: 'var(--bg-base)',
    padding: '40px 20px',
  },
  content: {
    maxWidth: '600px',
    margin: '0 auto',
  },
  title: {
    fontSize: '48px',
    fontWeight: '800',
    textAlign: 'center',
    marginBottom: '16px',
    background: 'var(--gradient-primary)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: {
    fontSize: '18px',
    textAlign: 'center',
    color: 'var(--text-secondary)',
    marginBottom: '48px',
  },
  pricingCard: {
    backgroundColor: 'var(--bg-elevated)',
    borderRadius: '20px',
    padding: '40px',
    border: '2px solid rgba(99, 102, 241, 0.3)',
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    top: '-12px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'var(--amber-500)',
    color: '#000',
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '700',
  },
  planName: {
    fontSize: '28px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '16px',
    textAlign: 'center',
  },
  pricing: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  originalPrice: {
    fontSize: '24px',
    fontWeight: '500',
    color: 'var(--text-muted)',
    textDecoration: 'line-through',
    marginRight: '12px',
  },
  price: {
    fontSize: '64px',
    fontWeight: '800',
    color: 'var(--text-primary)',
  },
  period: {
    fontSize: '24px',
    fontWeight: '500',
    color: 'var(--text-secondary)',
  },
  featuresList: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 32px 0',
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '12px',
    fontSize: '16px',
    color: 'var(--text-secondary)',
  },
  checkmark: {
    color: 'var(--indigo-500)',
    fontWeight: '700',
    fontSize: '20px',
  },
  subscribeButton: {
    width: '100%',
    background: 'var(--gradient-primary)',
    color: 'var(--text-primary)',
    padding: '16px 32px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '18px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  subscribeButtonLoading: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  secureNote: {
    textAlign: 'center',
    fontSize: '14px',
    color: 'var(--text-tertiary)',
    marginTop: '16px',
  },
  backButton: {
    display: 'block',
    margin: '32px auto 0',
    backgroundColor: 'transparent',
    color: 'var(--text-secondary)',
    padding: '12px 24px',
    borderRadius: '8px',
    border: '1px solid var(--border-light)',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
  },
};

export default Upgrade;
